import { Injectable } from "@angular/core";
import { PageBuilderLabelModel } from './label/page-builder-label.model';
import { PageBuilderNumericTextboxModel } from './numeric-textbox/page-builder-numeric-textbox.model';
import { PageBuilderBarcodeModel } from './barcode/page-builder-barcode.model';
import { PageBuilderQRCodeModel } from './qrcode/page-builder-qrcode.model';
import { PageBuilderImageModel } from './image/page-builder-image.model';
import { DynamicFormControlModel, DynamicFormService } from '@ng-dynamic-forms/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from './page-builder-components.models';
import { PageBuilderTextboxModel } from './textbox/page-builder-textbox.model';
import { PageBuilderDropdownModel } from './dropdown/page-builder-dropdown.model';
import { PageBuilderDatasourcesModel } from './datasources/page-builder-datasources.model';
import { PageBuilderColumnModel } from './column-builder/column-builder.model';
import { PageBuilderRowModel } from './row-builder/row-builder.model';
import { PageBuilderFilePickerModel } from './file-picker/page-builder-file-picker.model';
import { PageBuilderTextareaModel } from './textarea/page-builder-textarea.model';
import { PageBuilderHSeparatorModel } from './hseparator/page-builder-hseparator.model';

@Injectable()
export class PageBuilderComponentsService {
    constructor(
        private formService: DynamicFormService,
    ) {
    }

    doBuildPageBuilderModel(components: PageBuilderItem[]) {
        const formModels: DynamicFormControlModel[] = [];
        for (var c in components) {
            const component = components[c];
            switch(component.CODE) { 
                case PAGE_BUILDER_CODE_COMPONENT.TEXTBOX: {
                    const formModel = PageBuilderTextboxModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX: {
                    const formModel = PageBuilderNumericTextboxModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.TEXTAREA: {
                    const formModel = PageBuilderTextareaModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.LABEL: {
                    const formModel = PageBuilderLabelModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.DROPDOWN: {
                    const formModel = PageBuilderDropdownModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.DATASOURCE_PICKER: {
                    const formModel = PageBuilderDatasourcesModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.BARCODE: {
                    const formModel = PageBuilderBarcodeModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.IMAGE: {
                    const formModel = PageBuilderImageModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.QR_CODE: {
                    const formModel = PageBuilderQRCodeModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.FILE_PICKER: {
                    const formModel = PageBuilderFilePickerModel.initModel(component);
                    formModels.push(formModel);
                }
                break;

                case PAGE_BUILDER_CODE_COMPONENT.H_SEPARATOR: {
                    const formModel = PageBuilderHSeparatorModel.initModel(component);
                    formModels.push(formModel);
                }
                break;
            }
        }
        return formModels;
    }

    doBuildPageBuilderFormGroup(_formModels: DynamicFormControlModel[]) {
        return this.formService.createFormGroup(_formModels);
    }

    doGetPageBuilderComponents(): PageBuilderItem[] {
        return [
            PageBuilderLabelModel.getProperties(), 
            PageBuilderBarcodeModel.getProperties(), 
            PageBuilderQRCodeModel.getProperties(),
            PageBuilderImageModel.getProperties(),
            PageBuilderTextboxModel.getProperties(),
            PageBuilderNumericTextboxModel.getProperties(),
            PageBuilderColumnModel.getProperties(),
            PageBuilderRowModel.getProperties(),
            PageBuilderHSeparatorModel.getProperties(),
        ];
    }

}

